<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

  :root {
    --midnight:      #2C3E50;
    --light-grey:    #73767f;
    --dark-purple:   #2D1E73;
    --light-purple:  #6C68F4;
    --specter:       #DBE5EC;
    --red:           #E84230;

    --base-unit: 4px;
  }

  ::-moz-selection {
    color: #fff;
    background: var(--light-purple);
  }

  ::selection {
    color: #fff;
    background: var(--light-purple);
  }

  html {
    font-size: 62.5%!important;
    font-weight: 400!important;
    -webkit-font-smoothing: antialiased;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
  }

  body {
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol!important;
    font-size: 1.6rem!important;
    color: var(--midnight);
    line-height: normal;
  }

  /* Typography */

  h1 {
    font-size: 4.0rem;
    letter-spacing: 0;
    font-weight: 600;
    color: var(--midnight);
  }

  h2 {
    font-size: 3.0rem;
    letter-spacing: 0;
    font-weight: 600;
    color: var(--midnight);
  }

  .sub-heading {
    display: block;
    margin-bottom: 10px;
    font-size: 2.0rem;
    font-weight: 300;
    color: var(--light-grey);
  }

  p {
    margin: 0 0 calc(var(--base-unit) * 4) 0;
    font-size: 2.0rem;
  }

  .text-dark-purple {
    color: var(--dark-purple);
  }

  .text-center {
    text-align: center;
  }

  a {
    color: var(--dark-purple);
  }

  /* Forms */

  label,
  .v-label {
    font-size: 1.8rem;
    font-weight: 500;
    color: var(--midnight);
    display: block;
  }

  .v-messages__message {
    color: var(--red);
  }

  .card,
  .v-card {
    min-height: 700px!important;
    min-height: 100%;
    max-width: 1200px!important;
    margin: 64px auto;
    background: #ffffff;
    border: 1px solid var(--specter);
    border-radius: var(--base-unit);
    padding: 64px calc(var(--base-unit)*8);
    box-shadow: 0 3px 5px -1px rgba(0,0,0,0.10), 0 5px 8px 0 rgba(0,0,0,0.05), 0 1px 14px 0 rgba(0,0,0,0.05)!important;
  }

  .step-1,
  .step-2,
  .step-3,
  .v-stepper__items {
    min-width: 100vw;
    min-height: 100vh;
  }

  .simple-grid,
  .simple-grid .v-card {
    display: grid!important;
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: var(--base-unit);
  }

  @media screen and (max-width: 768px) {
    .simple-grid,
    .simple-grid .v-card {
      display: block !important;
    }

    .card,
    .v-card {
      padding: 32px calc(var(--base-unit)*4);
    }
  }

  .col-left {
    grid-column: 2 / 6;
    grid-row: auto;
  }

  .col-right {
    grid-column: 7 / 11;
    grid-row: auto;
  }

  .col-thirds--left {
    grid-column: 1 / 4;
  }

  .col-thirds--center {
    grid-column: 4 / 8;
  }

  .col-thirds--right {
    grid-column: 8 / 12;
  }

  .col-full {
    grid-column: 2 / 12;
    grid-row: auto;
  }

  .mt-1 { margin-top: var(--base-unit); }
  .mt-2 { margin-top: calc(var(--base-unit) * 2); }
  .mt-3 { margin-top: calc(var(--base-unit) * 3); }
  .mt-4 { margin-top: calc(var(--base-unit) * 4); }
  .mt-5 { margin-top: calc(var(--base-unit) * 5); }
  .mt-6 { margin-top: calc(var(--base-unit) * 6); }

  .mb-1 { margin-bottom: var(--base-unit); }
  .mb-2 { margin-bottom: calc(var(--base-unit) * 2); }
  .mb-3 { margin-bottom: calc(var(--base-unit) * 3); }
  .mb-4 { margin-bottom: calc(var(--base-unit) * 4); }
  .mb-5 { margin-bottom: calc(var(--base-unit) * 5); }
  .mb-6 { margin-bottom: calc(var(--base-unit) * 6); }

</style>
